<template>
<v-row class="im-result" no-gutters align="center">
    <div style="width: 30%">
        <div column class="px-2">
            <div class="text-capitalize regular py-1">{{ item.platform.name }}</div>
            <div class="detail py-1">{{ item.slug }}</div>
        </div>
    </div>
    <div v-for="(lang, index) in selected_languages" :key="index" class="px-2" :style="{width: width_col+'%'}">
        <div class="regular py-1" v-if="item.translations">{{ item.translations.title[lang] }}</div>
        <div class="detail py-1 block-ellipsis" v-if="item.translations" v-html="item.translations.body[lang]" />
    </div>
</v-row>
</template>

<script>
import defaults from "../utils/PropDefaults.js";

export default {
    props: {
        item: {
            type: Object,
            default: function () {
                return defaults.static_page_item
            }
        },
        selected_languages: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
        width_col: function () {
            let col = this.selected_languages.length;
            return Math.round(70 / col);
        }
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
    },

}
</script>

<style>
.block-ellipsis {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 40px;
    margin: 0 auto;
    line-height: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
